import { QueryClient } from '@tanstack/react-query'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { ThemeProvider } from '@emotion/react'

import { Layout } from '@/components/Layout'
import { AuthContextType } from '@/features/Auth/application/AuthContext'
import { theme } from '@/constants/breakpoints'
import { NotFoundPage } from '@/components/NotFound'

interface RouterContext {
  queryClient: QueryClient
  authContext: AuthContextType
}

export type { RouterContext }

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
})

function RootComponent() {
  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <Outlet />
      </Layout>
    </ThemeProvider>
  )
}
